import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/avatar1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleRight,
  faBars,
  faCaretDown,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from "react";
import constants from "../constants/constants";
import formattingFunctions from "../functions/formatting";
import { useUserParams } from "../hooks/useUserParams";

export default function Header() {
  const headerRef = useRef(null);
  const [menus, setMenus] = useState({
    buying: false,
    selling: false,
    info: false,
    locations: false,
  });
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [headerPosition, setHeaderPosition] = useState(100);
  const [headerTiming, setHeaderTiming] = useState(0.8);
  const location = useLocation();
  const [path, setPath] = useState(location.pathname);
  const lastScrollTop = useRef(0);
  const { getCurrentLogo } = useUserParams();

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  function setDropdown(key, bool) {
    setMenus((prevMenus) => {
      const temp = { ...prevMenus };
      Object.keys(temp).forEach((k) => {
        temp[k] = k === key ? bool : false;
      });
      return temp;
    });
  }

  function navClick() {
    setHeaderPosition(100);
    setHeaderTiming(0);
    setTimeout(() => {
      setHeaderTiming(0.8);
    }, 100);
    setMenus({ buying: false, selling: false, info: false, locations: false });
  }

  useEffect(() => {
    setPath(location.pathname);
  }, [location]);

  const adjustHeader = () => {
    const st = document.documentElement.scrollTop;
    const header = headerRef.current;

    if (!header) return;

    if (st !== 0) {
      header.classList.add("transparent-black");
    } else if (location.pathname === "/") {
      header.classList.remove("transparent-black");
    }

    if (st > lastScrollTop.current) {
      header.classList.add("hide-header");
    } else if (st < lastScrollTop.current) {
      header.classList.remove("hide-header");
    }

    lastScrollTop.current = st <= 0 ? 0 : st;
  };

  useEffect(() => {
    window.addEventListener("scroll", adjustHeader);
    return () => {
      window.removeEventListener("scroll", adjustHeader);
    };
  }, [location, path]);

  return (
    <>
      {windowSize > 1100 ? (
        <div
          ref={headerRef}
          id="Header"
          style={{ gridTemplateColumns: "1fr auto 1fr" }}
          className={`duration-700 w-full top-0 py-4 px-8 grid min-h-28 items-center fixed text-white z-50 ${
            path !== "/" ? "transparent-black" : ""
          }`}
        >
          <img src={getCurrentLogo()} className="w-24  object-cover" />
          <div className="flex gap-x-10 justify-center font-semibold child:relative mt-2">
            <Link to={"/"}>Home</Link>
            <Link to={"/about"}>About</Link>
            <div
              className="cursor-pointer pb-2"
              onMouseEnter={() => setDropdown("buying", true)}
              onMouseLeave={() => setDropdown("buying", false)}
            >
              Buying{" "}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 ${menus.buying ? "fa-flip-vertical" : ""}`}
              />
              {menus.buying && (
                <div className="absolute z-10 text-logo-second bg-white child:mx-1 child:my-1 child:px-2 child:py-2 child:text-center flex flex-col border-2 w-[200px] mt-2">
                  <Link
                    className="hover:bg-logo-second hover:text-white"
                    to={"/calculator"}
                  >
                    Mortgage Calculator
                  </Link>
                  <Link
                    className="hover:bg-logo-second hover:text-white"
                    to={"/listings"}
                  >
                    Residential Search
                  </Link>
                  <Link
                    className="hover:bg-logo-second hover:text-white"
                    to={"/commercial"}
                  >
                    Commercial Search
                  </Link>
                  <Link
                    className="hover:bg-logo-second hover:text-white"
                    to={"/buying-guide"}
                  >
                    Guide for Buyers
                  </Link>
                </div>
              )}
            </div>
            <div
              className="cursor-pointer"
              onMouseEnter={() => setDropdown("selling", true)}
              onMouseLeave={() => setDropdown("selling", false)}
            >
              Selling{" "}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 ${menus.selling ? "fa-flip-vertical" : ""}`}
              />
              {menus.selling && (
                <div className="absolute z-10 text-logo-second bg-white child:mx-1 child:my-1 child:px-2 child:py-2 child:text-center flex flex-col border-2 w-[200px] mt-2">
                  <Link
                    className="hover:bg-logo-second hover:text-white"
                    to={"/evaluation"}
                  >
                    Free Home Evaluation
                  </Link>
                  <Link
                    className="hover:bg-logo-second hover:text-white"
                    to={"/selling-guide"}
                  >
                    Guide for Sellers
                  </Link>
                </div>
              )}
            </div>
            <div
              className="cursor-pointer"
              onMouseEnter={() => setDropdown("info", true)}
              onMouseLeave={() => setDropdown("info", false)}
            >
              Information{" "}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 ${menus.info ? "fa-flip-vertical" : ""}`}
              />
              {menus.info && (
                <div className="absolute z-10 text-logo-second bg-white child:mx-1 child:my-1 child:px-2 child:py-2 child:text-center flex flex-col border-2 w-[200px] mt-2">
                  <Link
                    className="hover:bg-logo-second hover:text-white"
                    to={"/real-estate-reports"}
                  >
                    Real Estate Reports
                  </Link>
                </div>
              )}
            </div>
            <Link to={"/contact"}>Contact</Link>
          </div>
        </div>
      ) : (
        <>
          <div className="w-full h-32 z-30 flex justify-between items-center text-white absolute">
            <img src={getCurrentLogo()} className="w-24 mx-6 object-cover" />
            <div className="z-20 transition-opacity duration-700 ease-in-out w-full h-full absolute" />
            {headerPosition === 0 ? (
              <FontAwesomeIcon
                onClick={() => setHeaderPosition(100)}
                className="z-30 text-2xl px-4 mx-4 cursor-pointer fixed right-4"
                icon={faXmark}
              />
            ) : (
              <div
                style={{ backgroundColor: "rgba(70, 70, 70, .3)" }}
                className="z-30 rounded-full h-10 w-10 fixed right-7 flex items-center justify-center"
              >
                <FontAwesomeIcon
                  onClick={() => setHeaderPosition(0)}
                  className="z-30 text-xl px-4 mx-4 cursor-pointer"
                  icon={faBars}
                />
              </div>
            )}
          </div>
          <nav
            ref={headerRef}
            style={{
              transition: `translate ${headerTiming}s cubic-bezier(0, .52, 0, 1)`,
              translate: `${headerPosition}vw`,
            }}
            className={`flex flex-col text-white items-end gap-12 px-16 py-9 bg-logo-second fixed top-0 pt-44 z-20 w-full opacity-75 h-full child:tracking-wider child:font-bold`}
          >
            <Link
              onClick={() => {
                navClick();
              }}
              className={` ${path === "/" ? "active-page" : ""}`}
              to={"/"}
            >
              Home{" "}
              {path !== "/" ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              ) : (
                ""
              )}
            </Link>
            <Link
              onClick={() => {
                navClick();
              }}
              className={` ${path === "/about" ? "active-page" : ""}`}
              to={"/about"}
            >
              About{" "}
              {path !== "/about" ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              ) : (
                ""
              )}
            </Link>
            <span
              onClick={() => {
                setDropdown("buying", !menus.buying);
              }}
              className={`cursor-pointer`}
            >
              Buying{" "}
              {menus.buying ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleDown} />
              ) : (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              )}
            </span>
            {menus.buying && (
              <>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${
                    path === "/calculator" ? "active-page" : ""
                  } text-slate-400`}
                  to={"/calculator"}
                >
                  Mortgage Calculator{" "}
                  {path !== "/calculator" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${
                    path === "/listings" ? "active-page" : ""
                  }  text-slate-400`}
                  to={"/listings"}
                >
                  Listings{" "}
                  {path !== "/listings" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${
                    path === "/commercial" ? "active-page" : ""
                  }  text-slate-400`}
                  to={"/commercial"}
                >
                  Commercial Search{" "}
                  {path !== "/commercial" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${
                    path === "/buying-guide" ? "active-page" : ""
                  }  text-slate-400`}
                  to={"/buying-guide"}
                >
                  Buying Guide{" "}
                  {path !== "/buying-guide" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
              </>
            )}
            <span
              onClick={() => {
                setDropdown("selling", !menus.selling);
              }}
              className={`cursor-pointer`}
            >
              Selling{" "}
              {menus.selling ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleDown} />
              ) : (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              )}
            </span>
            {menus.selling && (
              <>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${
                    path === "/evaluation" ? "active-page" : ""
                  } text-slate-400`}
                  to={"/evaluation"}
                >
                  Free Home Evaluation{" "}
                  {path !== "/evaluation" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${
                    path === "/selling-guide" ? "active-page" : ""
                  } text-slate-400`}
                  to={"/selling-guide"}
                >
                  Selling Guide{" "}
                  {path !== "/evaluation" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
              </>
            )}
            <span
              onClick={() => {
                setDropdown("info", !menus.info);
              }}
              className={`cursor-pointer`}
            >
              Information{" "}
              {menus.info ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleDown} />
              ) : (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              )}
            </span>
            {menus.info && (
              <>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${
                    path === "/real-estate-reports" ? "active-page" : ""
                  } text-slate-400`}
                  to={"/real-estate-reports"}
                >
                  Free Real Estate Reports{" "}
                  {path !== "/real-estate-reports" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
              </>
            )}
            <Link
              onClick={() => {
                navClick();
              }}
              className={` ${path === "/contact" ? "active-page" : ""}`}
              to={"/contact"}
            >
              Contact{" "}
              {path !== "/contact" ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              ) : (
                ""
              )}
            </Link>
          </nav>
        </>
      )}
    </>
  );
}
